import type {
  BatchEventRequest,
  BatchEventResponse,
  GomarkePixelConfig,
} from '@/types';
import { normalizeBatchResponse } from '../core/batchResponse';
import { fetchWithTimeout } from './fetchWithTimeout';

const BATCH_ENDPOINT_PATH = '/pixels/public/event/batch';

/**
 * Envia um lote de eventos em uma única requisição.
 * Usar apenas quando a página estiver visível (não chamar no unload).
 */
export async function sendBatch(
  batch: BatchEventRequest,
  config: GomarkePixelConfig
): Promise<BatchEventResponse> {
  const url = `${config.apiEndpoint}${BATCH_ENDPOINT_PATH}`;

  const timeoutMs = config.timeout ?? 10_000;
  const response = await fetchWithTimeout(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(batch),
    keepalive: true,
    timeoutMs,
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const body = await response.json();
  return normalizeBatchResponse(body);
}
